exports.install = function (Vue, options) {
	//获取点位列表
	Vue.prototype.getdistribute = function(value)
	{
		return this.axiosget("/api/distribute/getList",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				for(let key in response.data.data.list)
				{
					response.data.data.list[key].m_terminal_all_json=this.MyJson(response.data.data.list[key].m_terminal_all_json);
					response.data.data.list[key].m_video_g_json=this.MyJson(response.data.data.list[key].m_video_g_json);
					response.data.data.list[key].m_video_bc_json=this.MyJson(response.data.data.list[key].m_video_bc_json);
				}
				this.$store.commit('distribute',response.data.data);
				this.$store.commit('setdw');
			}
			return response;
		})
	};
	//添加点位
	Vue.prototype.adddistribute = function(value)
	{
		return this.axiospost("/api/distribute/add",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				let val={
					qaedas_id: value.qaedas_id
				};
				this.getdistribute(value);
			}
			return response;
		});
	};
	//删除点位
	Vue.prototype.deldistribute = function(value)
	{
		this.axiospost("/api/distribute/delete",value)
		.then((response)=>{
			if(response.data.code==1)
			{
				let val={
					qaedas_id: value.qaedas_id
				};
				this.getdistribute(value);
			}
		});
	};
}